export const products = {
  starter: {
    priceId: import.meta.env.VITE_STRIPE_PRICE_STARTER || 'price_1RQcahHt4SrRcr9Th1naIuW2',
    productId: 'prod_starter',
    name: 'PromptGPT Starter',
    description: 'For beginners getting started with AI.',
    mode: 'subscription' as const,
    price: 5,
  },
  pro: {
    priceId: import.meta.env.VITE_STRIPE_PRICE_PRO || 'price_1RikHOHt4SrRcr9T2kmlW2tc',
    productId: 'prod_pro',
    name: 'PromptGPT Pro',
    description: 'For consistent learners going deeper.',
    mode: 'subscription' as const,
    price: 10,
  },
  team: {
    priceId: import.meta.env.VITE_STRIPE_PRICE_TEAM || 'price_1TRGF3Ht4SrRcr9TwLMPaWNi',
    productId: 'prod_UQ6RY4imuBOApa',
    name: 'PromptGPT Team',
    description: 'For small teams learning together.',
    mode: 'subscription' as const,
    price: 79,
  },
} as const;

export type ProductKey = keyof typeof products;

export const PRICE_TO_PLAN: Record<string, 'starter' | 'pro' | 'team'> = {
  [products.starter.priceId]: 'starter',
  [products.pro.priceId]: 'pro',
  [products.team.priceId]: 'team',
};
